import { render, staticRenderFns } from "./Istoric_login_list.vue?vue&type=template&id=13cf2993&scoped=true&"
import script from "./Istoric_login_list.vue?vue&type=script&lang=js&"
export * from "./Istoric_login_list.vue?vue&type=script&lang=js&"
import style0 from "./Istoric_login_list.vue?vue&type=style&index=0&id=13cf2993&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf2993",
  null
  
)

export default component.exports